export const SET_USER = 'AUTH/SET_USER'
export const SET_TOKEN = 'AUTH/SET_TOKEN'
export const SET_ACESSO = 'AUTH/SET_ACESSO'
export const SET_HEADER = 'AUTH/SET_HEADER'
export const SET_MENU = 'AUTH/SET_MENU'
export const SET_HTTP_ERROR = 'AUTH/SET_HTTP_ERROR'


